import { INote } from '@/types';
import { getUrl } from '@/utils/api';

function useNotes(contactId?: string) {
  const query = getUrl(`v1/notes/${contactId}`);
  return {
    ...query,
    data: query.data as INote[],
  };
}

export default useNotes;
